module.exports = __webpack_public_path__ + "assets/img/5115c5a0732c8e8a36b077888ceb2053.svg";